// installed dependecies
import React from 'react';
import { observer } from 'mobx-react-lite';
import {
    Route,
    BrowserRouter as Router,
    Redirect,
    useRouteMatch,
    useHistory,
    Switch,
} from 'react-router-dom';

// style dependencies
import { Body, Wrapper } from './layout/Styles'

// component dependencies
import { ROUTES } from './shared/constants'
import Login from './views/login'
import Dashboard from './views/dashboard';
import SecuredRoute from './SecuredRoute'
import PageNotFound from './layout/pageNotFound'
import AppNew from './appNew';
import { Auctions } from './views/auctions/index';
import { getPath, memberType, allStaticLookupData } from './data';
const { authorized, registered, unique } = memberType;
const routePaths = getPath();
// console.log('allStaticLookupData', allStaticLookupData);


const App = () => {

    const match = useRouteMatch();
    const history = useHistory();

    return (
        <Wrapper>
            <Body>



                <Router history={history} basename={process.env.PUBLIC_URL} key={Math.random()}>
                    <Switch>
                        <Route exact path='/login' component={Login} />
                        <Route exact path="/" component={Login} >
                            {/* <Redirect to={routePaths.login} /> */}
                        </Route>
                        <SecuredRoute path={routePaths.dashboard} component={Dashboard} />
                            
                        <Route component={PageNotFound} />
                    </Switch>
                </Router>
                {match.isExact && <Redirect to={`${match.url}`} />}
            
            
            </Body>
        </Wrapper>
    );
}

export default observer(App)
